import React from "react";
import App from "./App";
import "./index.css";
import { render } from "react-dom";

render(<App />, document.getElementById("root"));
